import MainDashboardView from '@Dashboard/views/index.vue';
// Global rules the removed Integrity Hub tabs used to load at this point (see the file's header).
import '@/styles/legacy-dashboard-globals.scss';
import CustomDashboard from './views/CustomDashboard.vue';
import CorrosionAnalyserView from '@Dashboard/views/CorrosionAnalyser.vue';
import AIAnalysisView from '@Dashboard/views/AIAnalysis.vue';
import AIAnalysisReportView from '@Dashboard/views/AIAnalysisReport.vue';
import permissions from '../Share/config/permissions';
import { log as debugLog } from '@/utils/debugLogger';
import { META_NEEDS_CHILD } from '@/router/notFound';

// The custom-dashboard route carries CustomDashboards.View permission meta.
debugLog(
	`[dashboard.routes] custom-dashboard route permission meta applied (CustomDashboards.View)`
);

export default [
	{
		path: '/:id/dashboard/inspection',
		component: MainDashboardView,
		meta: {
			requiresAuth: true,
			facilityScope: true,
			layout: 'viewer-layout',
			// The bare path has no tab of its own: it shows the not-found page (AVA-697 D7).
			[META_NEEDS_CHILD]: true,
		},
		children: [
			{
				path: 'corrosion-analyser',
				name: 'corrosion-analyser',
				component: CorrosionAnalyserView,
				meta: {
					requiresAuth: true,
					title: 'Corrosion Analyzer',
					layout: 'viewer-layout',
					// permissions: [permissions.CorrosionAnalyser.View],
				},
			},
			{
				path: 'ai-analysis',
				name: 'ai-analysis',
				component: AIAnalysisView,
				meta: {
					requiresAuth: true,
					title: 'AI Analysis',
					layout: 'viewer-layout',
					permissions: [permissions.Images360.View, permissions.AIAnalysis.View],
				},
			},
			{
				path: 'ai-analysis/:jobId',
				name: 'ai-analysis-job',
				component: AIAnalysisReportView,
				meta: {
					requiresAuth: true,
					title: 'AI Analysis Report',
					permissions: [permissions.Images360.View, permissions.AIAnalysis.View],
					layout: 'viewer-layout',
				},
			},
		]
	},
	{
		path: '/:id/dashboard/custom',
		component: CustomDashboard,
		name: 'custom-dashboard',
		meta: {
			requiresAuth: true,
			facilityScope: true,
			title: 'Explorer',
			layout: 'viewer-layout',
			permissions: [permissions.CustomDashboards.View]
		}
	}
]
